import GenericTrackerModule from '@mmt/legacy-commons/Native/GenericTrackerModule';
import GenericModule from '@mmt/legacy-commons/Native/GenericModule';

export const constants = {
  EVENT_NAME: 'event_name',
  ATTRIBUTE_1: 'attribute_sub1',
  ATTRIBUTE_2: 'attribute_sub2',
  ATTRIBUTE_3: 'attribute_sub3',
  ATTRIBUTE_4: 'attribute_sub4',
  ATTRIBUTE_5: 'attribute_sub5',
  ATTRIBUTE_6: 'attribute_sub6',
  ATTRIBUTE_7: 'attribute_sub7',
  ATTRIBUTE_8: 'attribute_sub8',
  ATTRIBUTE_9: 'attribute_sub9',
  ATTRIBUTE_10: 'attribute_sub10',
  ATTRIBUTE_11: 'attribute_sub11',
  ATTRIBUTE_12: 'attribute_sub12',
};

export const getDaySpentValue = async () => {
  if (GenericModule.getDaySpentValue) {
    return (await GenericModule.getDaySpentValue());
  }
  return '';
}

export const sendFirebaseEvent = (eventName: string, data: any) => {
  if (GenericTrackerModule.trackFirebase) {
    GenericTrackerModule.trackFirebase(eventName, data);
  }
};
